import { useCallback, useEffect, useState } from 'react';
import { siteApi } from '../admin/siteApi';

export const useKickletData = (path) => {
  const [data, setData] = useState(null), [error, setError] = useState(''), [busy, setBusy] = useState(true), [version, setVersion] = useState(0);
  const reload = useCallback(() => setVersion((value) => value + 1), []);
  useEffect(() => {
    const controller = new AbortController(); setBusy(true); setError('');
    siteApi(path, { signal: controller.signal }).then((value) => { if (!controller.signal.aborted) setData(value); })
      .catch((failure) => { if (!controller.signal.aborted) setError(failure.message); })
      .finally(() => { if (!controller.signal.aborted) setBusy(false); });
    return () => controller.abort();
  }, [path, version]);
  return { data, error, busy, reload, setData };
};

export const number = (value) => value == null ? '—' : value.toLocaleString();
export const vCredits = (minor) => (minor / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });